import FilterBy from "./FilterBy";
import SortBy from "./SortBy";

const ExploreFilter = ({ currentTab, moviesGenres, tvGenres }) => {
  return (
    <>
      <SortBy />
      <FilterBy
        currentTab={currentTab}
        moviesGenres={moviesGenres}
        tvGenres={tvGenres}
      />
    </>
  );
};

export default ExploreFilter;
